@if (environment.test) {
    <div class="test">
        Testomgeving
    </div>
}
<div class="shell">
    <app-sidebar [loggedIn]="!!LocalStorage.user"
                 [seireStatus]="seireStatus()"
                 [unapprovedLeaves]="LeaveService.unapprovedLeavesCount()"
                 [user]="currentUser"></app-sidebar>
    <div class="content">
        <router-outlet></router-outlet>
    </div>
</div>
